/* eslint eqeqeq: "off" */
import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { handleNextStep, handleStepBack, setPoliceReportNumber, setPoliceReportStation, setRegularDriverDropdown } from '../../../actions/claimSubmitActions';

class FnolStep7Sub1PoliceReport extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            showNotice: false,
            submitted: false,
            reportNumberValidation: true,
            reportStationValidation: true,
            cantSubmit: true,
            accordian0Open: false,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleNoticeBack = this.handleNoticeBack.bind(this);
        this.handleSkipSubmit = this.handleSkipSubmit.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        this.handlePoliceNumberChange = this.handlePoliceNumberChange.bind(this);
        this.handlePoliceStationChange = this.handlePoliceStationChange.bind(this);
    }

    async handleSubmit() {
        this.setState({ submitted: true })

        if (!this.state.reportStationValidation && !this.state.reportNumberValidation) {
            await this.props.dispatchSetRegularDriverDropdown()
            await this.props.dispatchHandleNextStep()
        }
    }

    async handleSkipSubmit() {
        await this.props.dispatchSetRegularDriverDropdown()
        await this.props.dispatchHandleNextStep()
    }

    async handleBack() {
        await this.props.dispatchHandleStepBack()
    }

    async handleNoticeBack() {
        await this.setState({ showNotice: false })
    }

    async handleSkip() {
        await this.setState({ showNotice: true })
    }

    async handlePoliceNumberChange(e: any) {
        await this.props.dispatchSetPoliceNumber(e.target.value)
        if (this.props.claimSubmit.policeReportNumber === "") {
            await this.setState({ reportNumberValidation: true, cantSubmit: true })
        }
        else {
            await this.setState({ reportNumberValidation: false, cantSubmit: false })
        }
    }

    async handlePoliceStationChange(e: any) {
        await this.props.dispatchSetPoliceStation(e.target.value)
        if (this.props.claimSubmit.policeReportStation === "") {
            await this.setState({ reportStationValidation: true, cantSubmit: true })
        } else {
            await this.setState({ reportStationValidation: false, cantSubmit: false })
        }
    }

    componentDidMount() {
        if (this.props.claimSubmit.policeReportNumber !== "" && this.props.claimSubmit.policeReportStation !== "") {
            this.setState({ cantSubmit: false, reportStationValidation: false, reportNumberValidation: false })
        }
        else {
            if (this.props.claimSubmit.policeReportNumber === "") {
                this.setState({ cantSubmit: true, reportNumberValidation: true })
            }
            if (this.props.claimSubmit.policeReportStation === "") {
                this.setState({ cantSubmit: true, reportStationValidation: true })
            }
        }
    }

    public render() {
        let backNotice = <button id="backButtonNotice" className="btn btn-outline-red w-100" onClick={this.handleNoticeBack}>Back</button>
        let okayNotice = <button id="okayButtonNotice" className="btn btn-solid-red w-100" onClick={this.handleSkipSubmit}>Okay</button>
        let nextReport = <button id="nextButton" className="btn btn-solid-red w-100" disabled={this.state.cantSubmit} onClick={this.handleSubmit}>Next</button>
        let backReport = <button id="backButton" className="btn btn-outline-red w-100" onClick={this.handleBack}>Back</button>
        return (
            <>
                {!this.state.showNotice &&
                    <div id="claimPoliceReport" className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding">
                        <div className="row noma">
                            <div className="col-12 nopa ssp-header-fnol-claim-info">
                                <div className="row noma">
                                    <div className="fnol-step-header-icon-area">
                                        {isMobile &&
                                            <img src='/my-policy/Images/Claims/Numbers/7-red.png' alt="Step 7" title="Step 7" />
                                        }
                                        {!isMobile &&
                                            <img src='/my-policy/Images/Claims/Numbers/6-red.png' alt="Step 6" title="Step 6" />
                                        }
                                    </div>
                                    <div className="col fnol-step-header-title-area">
                                        <h3>Police report</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row noma">
                            <div className="col-12 fnol-steps-form-section-holder">
                                <hr className="hr-minus21px" />
                                <p className="fnol-form-intro-p">
                                    What is the police report number. If you don't have it right now, that's okay, you can just hit 'Skip'
                        </p>
                            </div>
                            <div className="col-12 nopa ssp-form">
                            <div className={'form-group mb-30px' + (this.state.Step1Submitted && !this.props.claimSubmit.policeReportNumber ? 'has-error' : '')}>
                                    <label className={'form-label' + (this.props.claimSubmit.policeReportNumber !== "" ? "" : " no-opacity")}>Police report no.</label>
                                    <input id="policeReportNumberInput" placeholder="Police report no." className={"form-control " + (this.state.submitted && !this.props.claimSubmit.policeReportNumber ? 'form-control-error' : "underline")} name="policeReportNumber" value={this.props.claimSubmit.policeReportNumber} onChange={this.handlePoliceNumberChange} />
                                    {this.state.submitted && !this.props.claimSubmit.policeReportNumber &&
                                        <div className="form-inline-error">Police report no. is required</div>
                                    }
                                </div>
                                <div className={'form-group noma mt-20px' + (this.state.Step1Submitted && !this.props.claimSubmit.policeReportStation ? 'has-error' : '')}>
                                    <label className={'form-label' + (this.props.claimSubmit.policeReportStation !== "" ? "" : " no-opacity")}>Police station</label>
                                    <input id="policeReportStationInput" type="text" placeholder="Police station" className={"form-control " + (this.state.submitted && !this.props.claimSubmit.policeReportStation ? 'form-control-error' : "underline")} name="policeReportStation" value={this.props.claimSubmit.policeReportStation} onChange={this.handlePoliceStationChange} />
                                    {this.state.submitted && !this.props.claimSubmit.policeReportStation &&
                                        <div className="form-inline-error">Police station details are required</div>
                                    }
                                </div>
                            </div>
                            <div className="row nopa nopa w-100 mt-10px noma">
                                <div className="col-sm-12 col-lg-4 mt-10px">
                                    {isMobile &&
                                        nextReport}
                                    {!isMobile &&
                                        backReport}
                                </div>
                                <div className="col-sm-12 col-lg-4 mt-10px">
                                    {isMobile &&
                                        backReport}
                                    {!isMobile &&
                                        nextReport}
                                </div>
                                <div className="col-sm-12 col-lg-4 mt-10px">
                                    <button id="skipButton" className="btn btn-clear-red w-100" onClick={this.handleSkip}>Skip</button>
                                </div>
                            </div>
                            <div className="fnol-get-info-ready-please-note-box mt-15px">
                                <p className="fnol-get-info-ready-please-note-header">
                                    <b>Please note: Tell the police</b>
                                </p>
                                <div className="nopa ml-5px">
                                    <p className="bullet">If you&apos;ve been involved in an accident and someone was injured or someone&apos;s property was damaged, you must report it to the police as soon as possible, even if there&apos;s no damage to your car or motorbike.<br /></p>
                                    <p className="bullet">If you&apos;ve suffered a theft, hi-jacking, burglary or any crime-related incident, you must tell the police immediately after becoming aware of the incident.<br /></p>
                                    <p className="bullet">Tap <a target='_blank' href='https://online.natis.gov.za/crash/#/onlineCrashReport' className='font-weight-bold text-decoration-underline text-black'>here</a> to see which cases can be reported online. Cases that can&apos;t be reported this way need to be reported to a police station.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.showNotice &&
                    <div id="claimPoliceReportNotice" className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding">
                        <div className="row noma">
                            <div className="col-12 nopa ssp-header-fnol-claim-info">
                                <div className="row noma">
                                    <div className="fnol-step-header-icon-area">
                                        {isMobile &&
                                            <img src='/my-policy/Images/Claims/Numbers/7-red.png' alt="Step 7" title="Step 7" />
                                        }
                                        {!isMobile &&
                                            <img src='/my-policy/Images/Claims/Numbers/6-red.png' alt="Step 6" title="Step 6" />
                                        }
                                    </div>
                                    <div className="col fnol-step-header-title-area">
                                        <h3>Police report</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='fnol-steps-form-section-holder'>
                            <hr className="hr-minus21px" />
                            <div className="nopa">
                                <p><b>Please note: Tell the police</b></p>
                            </div>
                            <div className="nopa ml-10px">
                                <p className="bullet">If you&apos;ve been involved in an accident and someone was injured or someone&apos;s property was damaged, you must report it to the police as soon as possible, even if there&apos;s no damage to your car or motorbike.<br /><br /></p>
                                <p className="bullet">If you&apos;ve suffered a theft, hi-jacking, burglary or any crime-related incident, you must tell the police immediately after becoming aware of the incident.<br /><br /></p>
                                <p className="bullet">Tap <a target='_blank' href='https://online.natis.gov.za/crash/#/onlineCrashReport' className='font-weight-bold text-decoration-underline text-black'>here</a> to see which cases can be reported online. Cases that can&apos;t be reported this way need to be reported to a police station.</p>
                            </div>
                            <div className="row noma nopa w-100 mt-10px">
                                <div className="col-sm-12 col-lg-6 mt-10px">
                                    {isMobile &&
                                        okayNotice}
                                    {!isMobile &&
                                        backNotice}
                                </div>
                                <div className="col-sm-12 col-lg-6 mt-10px">
                                    {isMobile &&
                                        backNotice}
                                    {!isMobile &&
                                        okayNotice}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchSetRegularDriverDropdown: () => dispatch(setRegularDriverDropdown()),
        dispatchSetPoliceNumber: (reportNumber: string) => dispatch(setPoliceReportNumber(reportNumber)),
        dispatchSetPoliceStation: (reportStation: string) => dispatch(setPoliceReportStation(reportStation)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep7Sub1PoliceReport);